module.exports = __webpack_public_path__ + "img/home-lazer.0157214e.svg";